<template>
  <div class="col-md-12 !tw-mx-auto registration">
    <div class="login-logo">
      <img
        :src="logo"
        alt="logo"
      >
    </div>

    <form
      :class="{ loading: loading, error: error }"
      @submit.prevent
    >
      <Card class="pt-20 card-login">
        <section>
          <div class="row row-r">
            <div class="col-md-12 col-12">
              <h3 class="m-0 registration__title">
                {{ $t('registration.get_started') }}
              </h3>
            </div>
            <div class="col-md-12 col-12 registration__login-back login-back-stik">
              <span class="login-back-stik__title tw-mr-4">{{ $t('registration.already_acc') }}</span>
              <RouterLink
                to="/"
                class="login-back-stik__link"
              >
                {{ $t('registration.log_in') }}
              </RouterLink>
              <LanguageSelect />
            </div>
          </div>
          <div class="row">
            <p class="col-12 registration__sub-title">
              {{ $t('registration.start_work') }}
            </p>
          </div>
          <div class="row">
            <div class="col-md-6 mb-16">
              <UiInput
                v-model="model.email"
                v-model:error="errors_.email"
                :label="$t('customReports.e_mail')"
                wrapper-type="registration"
                :placeholder="$t('forms.emailPlaceholder')"
                required
                error-clear-on-change
              />
            </div>
            <div class="col-md-6 mb-16">
              <UiSelect
                v-model="model.currency_code"
                :label="$t('profile.generalInfo.currency')"
                :list="customerCurrencies"
                is-search
                required
                type="registration"
              />
            </div>
            <div class="col-md-6 mb-16">
              <UiInput
                v-model="model.password"
                v-model:error="errors_.password"
                :label="$t('profile.generalInfo.password')"
                type="password"
                wrapper-type="registration"
                placeholder="********"
                required
                error-clear-on-change
              />
            </div>
            <div class="col-md-6 mb-16">
              <UiInput
                v-model="model.password2"
                v-model:error="errors_.password2"
                :label="$t('registration.password_confirm')"
                type="password"
                wrapper-type="registration"
                placeholder="********"
                required
                error-clear-on-change
              />
            </div>
            <div class="col-md-6 mb-16">
              <UiInput
                v-model="model.first_name"
                v-model:error="errors_.first_name"
                :label="$t('profile.generalInfo.firstName')"
                wrapper-type="registration"
                :placeholder="$t('registration.placeholder_firstname')"
                required
                error-clear-on-change
              />
            </div>
            <div class="col-md-6 mb-16">
              <UiInput
                v-model="model.last_name"
                v-model:error="errors_.last_name"
                :label="$t('registration.surname')"
                wrapper-type="registration"
                :placeholder="$t('registration.placeholder_surname')"
                required
                error-clear-on-change
              />
            </div>

            <div class="col-md-6 col-12 mb-16">
              <UiDatePicker
                v-model="model.date_of_birth"
                v-model:error="errors_.date_of_birth"
                :label="$t('profile.generalInfo.birthDate')"
                :placeholder="$t('registration.placeholder_birth')"
                type-wrapper="registration"
                required
                :default-value="defaultDateView"
                :disabled-date="disabledDate"
              />
            </div>

            <!--contact number-->

            <div class="col-md-6 col-12 mb-16">
              <UiInputPhone
                v-if="isGeoLoad"
                v-model="model.phone_number"
                v-model:error="errors_.phone_number"
                :label="$t('profile.generalInfo.contactNumber')"
                :placeholder="$t('registration.placeholder_number')"
                :initial-country="model.country_code"
                type="registration"
              />
            </div>

            <!--messenger-->

            <div class="col-md-6 col-12 mb-16">
              <UiSelect
                v-model="model.messenger"
                v-model:error="errors_.messenger"
                :label="$t('profile.generalInfo.messenger')"
                :placeholder="$t('profile.generalInfo.notSpecified')"
                :list="messengers"
                is-search
                required
                type="registration"
              />
            </div>

            <div class="col-md-6 col-12 mb-16 registration__messenger-id">
              <UiInput
                v-model="model.messenger_id"
                v-model:error="errors_.messenger_id"
                :label="$t('profile.generalInfo.messengerId')"
                :placeholder="messengerIdPlaceholder"
                wrapper-type="registration"
                required
                error-clear-on-change
              />
            </div>

            <div class="col-md-6 col-12 mb-16 registration__country">
              <UiSelect
                v-model="model.country_code"
                v-model:error="errors_.country_code"
                :label="$t('profile.generalInfo.country')"
                :placeholder="$t('registration.placeholder_country')"
                :list="countries"
                is-search
                required
                type="registration"
              />
            </div>
            <div class="col-md-6 col-12 mb-16 registration__city">
              <UiInput
                v-model="model.city"
                v-model:error="errors_.city"
                :label="$t('profile.generalInfo.city')"
                :placeholder="$t('registration.placeholder_city')"
                wrapper-type="registration"
                error-clear-on-change
              />
            </div>
            <div class="col-md-6 col-12 mb-16">
              <UiInput
                v-model="model.address"
                v-model:error="errors_.address"
                :label="$t('profile.generalInfo.address')"
                :placeholder="$t('profile.generalInfo.address')"
                wrapper-type="registration"
                error-clear-on-change
              />
            </div>
            <div class="col-md-6 col-12 mb-16">
              <UiInput
                v-model="model.postal_code"
                v-model:error="errors_.postal_code"
                :label="$t('profile.generalInfo.postal_code')"
                :placeholder="$t('profile.generalInfo.postal_code')"
                wrapper-type="registration"
                error-clear-on-change
              />
            </div>
          </div>
          <div
            v-show="isCaptchaV2Required"
            class="row tw-mt-16"
          >
            <div class="col-12 captcha">
              <VueRecaptcha
                ref="captchaV2"
                :sitekey="$store.state.misc.miscSettings.recaptcha.public_key_v2"
                @verify="verifyV2"
              />
            </div>
          </div>
          <div class="row tw-mt-16">
            <div class="col-md-6 col-12">
              <div class="registration__agree agree-check">
                <!-- vue3-migration -- slot="actionsAppend" слишком глубоко -->
                <div class="checkbox payment-history__checkbox">
                  <input
                    id="checkbox1"
                    v-model="payouts"
                    type="checkbox"
                    class="agree-check__input"
                  >
                  <label
                    class="checkbox-label agree-check__label"
                    :class="{
                      payouts: payouts,
                    }"
                    for="checkbox1"
                  />
                  <label class="agree-check__label-p lppp">
                    {{ $t('registration.agree.1') }}
                    <a
                      :href="rules.tos_url"
                      :class="{ 'pasive-p': !rules.tos_url }"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="agree-check__accent-p"
                    >
                      {{ $t('registration.agree.2') }}
                    </a>
                    {{ rules.privacy_policy_url && '&' }}
                    <a
                      v-if="rules.privacy_policy_url"
                      :href="rules.privacy_policy_url"
                      class="agree-check__accent-p"
                      :class="{ 'pasive-p': !rules.privacy_policy_url }"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ $t('registration.agree.3') }}
                    </a>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-12">
              <button
                v-loading="loading"
                :disabled="(isCaptchaV2Required && !recaptchaTokenV2) || loading || !payouts"
                class="btn btn-primary btn-block big login btn-md"
                @click.prevent="handlerSubmit({ isBtnClick: true })"
              >
                {{ $t('forms.btn.submit') }}
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="registration__footer-text">
                {{ $t('registration.captcha.1') }}
                <a
                  href="https://policies.google.com/privacy"
                  class="agree-check__accent-p"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ $t('registration.captcha.2') }}
                </a>
                {{ $t('registration.captcha.3') }}
                <a
                  href="https://policies.google.com/terms"
                  class="agree-check__accent-p"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ $t('registration.captcha.4') }}.
                </a>
              </p>
            </div>
          </div>
        </section>
      </Card>
      <div class="loading__block">
        <i class="fa fa-spinner fa-3x fa-fw login__spinner" />
      </div>
    </form>
  </div>
</template>

<script>
import { required, email, minLength } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import moment from 'moment';
import cookieProvider from '@/lib/cookieProvider';
import _ from '@/lib/lodash';
import LanguageSelect from './components/LanguageSelect.vue';

export default {
  components: { LanguageSelect },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      isCaptchaV2Required: false,
      recaptchaTokenV2: null,
      recaptchaTokenV3: null,
      emailValidation: false,
      passwordValidation: false,
      loading: false,
      isGeoLoad: false,
      model: {
        email: '',
        password: '',
        password2: '',
        first_name: '',
        last_name: '',
        date_of_birth: '',
        country_code: '',
        city: '',
        messenger: '',
        messenger_id: '',
        referred_by: '',
        address: '',
        postal_code: '',
        currency_code: '',
      },
      country_code: '',
      payouts: true,
      isShowPassword: false,
      isShowPasswordConf: false,
      errors_: {
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        date_of_birth: '',
        phone_number: '',
        country_code: '',
        city: '',
        messenger: '',
        messenger_id: '',
        referred_by: '',
        recaptcha_token: '',
        address: '',
        postal_code: '',
        password2: '',
      },

      defaultDateView: moment().subtract(18, 'year').toDate(),
      disabledDate: (time) => {
        return time.setFullYear(time.getFullYear() + 18) > Date.now();
      },
    };
  },

  created() {
    this.$store.dispatch('getCountries');
    this.$store.dispatch('getMessengers');
    this.getGeoData();
    this.getCustomerCurrencies();
  },

  computed: {
    // password2Error() {
    //   return _.get(this.errors_, ['password2', 0, 'message']) || _.get(this.errors_, ['password', 0, 'message'])
    // },
    messengerIdPlaceholder() {
      if (this.model.messenger) {
        return (
          this.$store.state.misc.messengers.find((e) => e.id === this.model.messenger)?.example_placeholder ||
          this.$t('registration.placeholder_messenger_id')
        );
      }
      return this.$t('registration.placeholder_messenger_id');
    },
    rules() {
      return this.$store.getters.getterMiscSetting.rules;
    },

    customerCurrencies() {
      return this.$store.state.misc.customerCurrencies.map((e) => ({
        id: e.code,
        text: e.code,
      }));
    },

    messengers() {
      return this.$store.state.misc.messengers.map((e) => ({
          id: e.id,
          text: e.name,
        }));
    },

    disabledSubmit() {
      return (
        this.model.password !== this.password2 ||
        this.model.password === '' ||
        this.model.email === '' ||
        this.model.first_name === '' ||
        this.model.last_name === '' ||
        this.model.messenger === '' ||
        this.model.messenger_id === '' ||
        this.model.country_code === '' ||
        this.model.date_of_birth === '' ||
        this.payouts !== true
      );
    },

    countries() {
      return this.$store.state.misc.countries.map((e) => {
        e.id = e.code;
        e.text = `${e.name} - ${e.name_native}`;
        return e;
      });
    },

    valid_email() {
      const _email = this.v$.model.email;
      return _email.email && _email.required;
    },

    error() {
      return this.$store.state.errors.request >= 400;
    },
    logo() {
      return this.$config.layout.logoFull;
    },
  },

  watch: {
    'model.messenger': {
      handler(value) {
        if (value && this.model.messenger_id) {
          this.model.messenger_id = '';
        }
      },
    },
  },

  methods: {
    verifyV2(token) {
      this.recaptchaTokenV2 = `google_recaptcha_v2__${token}`;
    },
    async getGeoData() {
      try {
        await this.$store.dispatch('getGeoData');
        this.model.country_code = this.$store.state.misc.geoData.country_code;
        this.model.city = this.$store.state.misc.geoData.city_name;
        this.isGeoLoad = true;
      } finally {

      }
    },

    async getCustomerCurrencies() {
      await this.$store.dispatch('getCustomerCurrencies');
      this.model.currency_code =  this.$store.state.misc.customerCurrencies.find((el) => !!el.is_default)?.code;
    },

    async recaptcha() {
      try {
        if (await this.$recaptchaLoaded()) {
          const token = await this.$recaptcha('registration');
          this.recaptchaTokenV3 = `google_recaptcha_v3__${token}`;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async handlerSubmit({ isBtnClick = false } = {}) {
      this.resetError();

      if (this.model.password !== this.model.password2) {
        this.errors_.password2 = [{
          message: this.$t('profile.changePassword.dontMatch'),
        }];

        this.errors_.password = [{
          message: this.$t('profile.changePassword.dontMatch'),
        }];

        return;
      }

      this.loading = true;
      this.model.referred_by = cookieProvider.get('referred_by') || '';

      await this.recaptcha();
      const recaptcha_token = this.recaptchaTokenV2 || this.recaptchaTokenV3;

      try {
        const data = {
          ...this.model,
          ...(recaptcha_token && { recaptcha_token }),
        };
        await this.$api.postAuthRegister(data);
        this.$router.push('/registration-confirm');
      } catch (error) {
        const { errors } = error.response.data;
        this.errors_ = { ...this.errors_, ...errors };

        if ((Object.keys(errors).length === 1 && errors.hasOwnProperty('recaptcha_token'))) {
          if (!this.recaptchaTokenV3 || (isBtnClick && !this.recaptchaTokenV2)) {
            await this.handlerSubmit();
            return;
          }

          if (!this.recaptchaTokenV2) {
            this.isCaptchaV2Required = true;
            this.loading = false;
            return;
          }

          this.$alert.error(this.$t('alerts.captchaRequestFailed'));
        }

        this.loading = false;

      } finally {
        this.$refs.captchaV2?.reset();
        this.recaptchaTokenV2 = null;
      }
    },

    resetError() {
      this.errors_ = {
        email: '',
        password: '',
        password2: '',
        first_name: '',
        last_name: '',
        date_of_birth: '',
        phone_number: '',
        country_code: '',
        city: '',
        messenger: '',
        messenger_id: '',
        referred_by: '',
        recaptcha_token: '',
        address: '',
        postal_code: '',
      };
    },
  },
  validations: {
    model: {
      password: {
        required,
        minLength: minLength(8),
      },
      email: {
        required,
        email,
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.captcha {
  display: flex;
  justify-content: center;
  margin-top: -12px;
  margin-bottom: 16px;
}

.v-select {
  // /deep/ {
    // vue3-migration -- удаляем /deep/
    :deep(.select2-container.select2) {
      z-index: 0;
    }
    :deep(.selection .select2-selection) {
      border: none !important;
      background: transparent;
      border-bottom: 2px solid #ccc !important;
      border-radius: initial;
      padding: 11px 30px 5px 1px;
      height: fit-content;

      .select2-selection__rendered {
        padding-left: 0;
        color: #000;
      }

      .select2-selection__placeholder {
        color: #7d7d7d !important;
      }

      .select2-selection__arrow {
        height: 100%;
        color: #6c757d !important;
        opacity: 0.3;
      }
    }

    :deep(.select2-container--open .select2-selection) {
      border-color: var(--color-bg-primary-hover) !important;
    }
  // }
}
</style>

<style lang="scss">
// vue3-migration -- импорт неиспользуемого css
// @import '~flatpickr/dist/flatpickr';
</style>
